import { useTranslation } from "react-i18next";

import DefaultAuth from "../DefaultAuth";
import SetNewPasswordForm from "../Forms/SetNewPassword";

export default function SetNewPassword() {
	const { t } = useTranslation();

	return (
		<DefaultAuth
			Form={SetNewPasswordForm}
			title={t("auth.resetPassword.setPassword.title")}
		/>
	);
}
